import React, { ReactNode } from 'react';
import CompaniesProvider from '../companies/components/CompaniesProvider';
import ContactsProvider from '../contacts/components/ContactsProvider';
import InternalProjectContactsProvider from '../projects/components/InternalProjectContactsProvider';
import ProjectsProvider from '../projects/components/ProjectsProvider';
import OfficesProvider from '../companies/components/OfficeProvider';
import AccessRightsContextProvider from '../users/components/AccessRightsContextProvider';
import { MailFilterContextProvider } from '../mail/components/MailSearch/MailFilterContext';
import useBeforeUnloadBrowser from '../../hooks/useBeforeUnloadBrowser';
import useDocumentVisible from '../../hooks/useDocumentVisible';

interface MainProviderProps {
  children?: ReactNode;
}

export const MainProvider: React.FC<MainProviderProps> = (props) => {
  //#region ------------------------------ Defaults
  const { children } = props;
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects

  //#endregion

  return (
    <>
      <HiddenComponent />
      <MailFilterContextProvider>
        <ProjectsProvider>
          <CompaniesProvider>
            <ContactsProvider>
              <OfficesProvider>
                <InternalProjectContactsProvider>
                  <AccessRightsContextProvider>
                    {children}
                  </AccessRightsContextProvider>
                </InternalProjectContactsProvider>
              </OfficesProvider>
            </ContactsProvider>
          </CompaniesProvider>
        </ProjectsProvider>
      </MailFilterContextProvider>
    </>
  );
};

export default MainProvider;

const HiddenComponent = () => {
  useBeforeUnloadBrowser();
  useDocumentVisible();
  return <></>;
};
